import React from "react";
import {StoreContext} from '../providers';

function useStore() {
    return React.useContext(StoreContext);
}

export {useStore}
